module.exports = __webpack_public_path__ + "img/third-logo.0c7bd910.png";